module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1185.75e5028c.png";